import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoshanishingnapur() {



  const cardData =
  {
    keyword: 'Mumbai to Shani Shingnapur Cab',
    heading: 'Shambhu Cabs: Mumbai to Shani Shingnapur Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Shani Shingnapur Cab services, providing safe, comfortable, and hassle-free travel for devotees, families, friends, and corporate travelers visiting the holy town of Shani Shingnapur. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Shani Shingnapur with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your pilgrimage or trip convenient, stress-free, and memorable. For trusted, comfortable, and safe travel, Shambhu Cabs is your preferred choice for Mumbai to Shani Shingnapur cab services.',

    top: 'Top Places to Visit in Shani Shingnapur with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Shani Shingnapur Temple",
    "description": "Shani Shingnapur Temple is a unique and famous shrine in Maharashtra dedicated to Lord Shani (Saturn). Known for its open-air deity installation without a roof, the temple has no doors in the village houses as it is believed that Lord Shani protects the villagers from theft and crime. Devotees from across India visit to seek blessings, perform rituals, and participate in special ceremonies, especially on Saturdays. The village’s strict adherence to honesty and faith adds a spiritual and cultural significance to the pilgrimage."
  },
  {
    "title": "Shani Shingnapur Main Street",
    "description": "The bustling main street leading to the temple is lined with shops selling religious items, souvenirs, and local handicrafts. Visitors enjoy exploring the vibrant market, buying offerings for the deity, and experiencing the local culture. Street vendors serve traditional snacks and refreshments, creating a lively atmosphere that complements the spiritual journey."
  },
  {
    "title": "Shani Shingnapur Observation Points",
    "description": "Several spots around the temple offer panoramic views of the village, surrounding fields, and the temple complex. These observation points are ideal for photography, capturing the unique architecture of the temple, and observing the daily life of devotees and villagers who live in harmony under Lord Shani’s protection."
  },
  {
    "title": "Shani Shingnapur Ritual Halls",
    "description": "The temple complex includes dedicated halls for performing religious rituals, prayers, and special ceremonies. Devotees participate in chanting, offerings, and group prayers, especially on weekends and during Shani Jayanti. The halls provide a calm and spiritual environment for meditation and connecting with the deity."
  },
  {
    "title": "Local Food Stalls",
    "description": "Visitors can enjoy traditional Maharashtrian snacks and sweets at local food stalls near the temple. Items like vada pav, puran poli, and fresh coconut water are popular among pilgrims. The food stalls add a vibrant and cultural touch to the visit, allowing tourists to experience local flavors."
  },
  {
    "title": "Nearby Villages and Countryside",
    "description": "The surrounding countryside and nearby villages offer scenic views of fields, hills, and traditional rural Maharashtra. Visitors can take short drives or walks to explore the rustic charm, meet local villagers, and experience the simple lifestyle that has coexisted with the temple’s traditions for centuries."
  },
  {
    "title": "Shani Shingnapur Photography Spots",
    "description": "Several areas around the temple and village provide excellent opportunities for photography, including the deity, unique open-air temples, village streets, and cultural activities. Photographers can capture both spiritual and everyday life elements, making it a rewarding experience for travel and cultural photography enthusiasts."
  },
  {
    "title": "Temple Festival Area",
    "description": "During major festivals like Shani Jayanti and Saturdays, the temple grounds are decorated with flowers, lights, and ceremonial items. Special rituals, processions, and devotional music take place, attracting thousands of pilgrims. The festive atmosphere showcases the vibrant cultural and spiritual life of Shani Shingnapur."
  },
  {
    "title": "Accommodation and Pilgrim Amenities",
    "description": "Shani Shingnapur offers several guesthouses, dharmashalas, and small hotels for pilgrims. These facilities provide basic amenities, meals, and convenience for visitors staying overnight. The proximity to the temple allows devotees to participate in early morning rituals and extended worship sessions."
  },
  {
    "title": "Souvenir Shops",
    "description": "Various shops around the temple sell religious souvenirs, idols, jewelry, and memorabilia related to Lord Shani. Visitors can purchase keepsakes to remember their pilgrimage and share spiritual gifts with family and friends. The shops add a commercial and cultural dimension to the temple visit, blending faith and local craftsmanship."
  }
],




"services": [
  {
    "name": "Mumbai Shani Shingnapur Taxi Service",
    "description": "Mumbai Shani Shingnapur Taxi Service provides a reliable and comfortable pilgrimage travel experience for devotees visiting the sacred Shani Temple. With professional drivers, clean AC cars, and punctual pickup from any location in Mumbai, this service ensures a smooth and spiritually refreshing journey. Ideal for individuals, families, and groups seeking a peaceful and well-managed travel experience."
  },
  {
    "name": "Shani Temple Cab Mumbai",
    "description": "Shani Temple Cab Mumbai offers dedicated temple-focused travel for devotees heading to Shani Shingnapur. The service ensures a safe, hassle-free journey with experienced drivers who understand the route well. Travellers enjoy clean vehicles, flexible timing, and an overall smooth darshan experience from Mumbai to the Shani Temple."
  },
  {
    "name": "Mumbai to Shani Shingnapur One Way Cab",
    "description": "Mumbai to Shani Shingnapur One Way Cab is a cost-effective travel option for passengers needing a single-direction trip to the holy temple. With transparent pricing, timely pickups, and comfortable AC sedans and SUVs, this service makes the long-distance pilgrimage journey easy, comfortable, and affordable."
  },
  {
    "name": "Pune–Shani Shingnapur Taxi via Mumbai",
    "description": "Pune–Shani Shingnapur Taxi via Mumbai provides a convenient intercity option for passengers who need to start their journey from Mumbai and travel through Pune en route to the Shani Temple. This flexible cab service supports multi-location pickups, long-route comfort, and a smooth devotional travel experience."
  },
  {
    "name": "Affordable Cab Mumbai Shani Shingnapur",
    "description": "Affordable Cab Mumbai Shani Shingnapur ensures budget-friendly travel for devotees without compromising comfort or safety. Offering clean sedans, economy SUVs, and dependable drivers, this service is designed for travellers seeking a spiritual journey at economical fares with complete peace of mind."
  },
  {
    "name": "Pilgrimage Cab Mumbai Shani Shingnapur",
    "description": "Pilgrimage Cab Mumbai Shani Shingnapur is a dedicated travel service for religious tours, providing calm, comfortable, and respectful transportation for devotees. The cab includes ample space, smooth driving, and flexibility in scheduling temple darshan, making it perfect for families and elderly passengers."
  },
  {
    "name": "24x7 Cab Mumbai Shani",
    "description": "24x7 Cab Mumbai Shani offers round-the-clock travel availability for early morning darshan, late-night departures, or urgent trips to Shani Shingnapur. With instant booking support, reliable drivers, and safe long-distance travel, passengers can begin their religious journey at any hour with ease."
  },
  {
    "name": "Sedan Cab Mumbai Shani Shingnapur",
    "description": "Sedan Cab Mumbai Shani Shingnapur provides a comfortable, smooth, and economical travel option for small families or solo travellers. Sedans like Dzire and Etios offer AC comfort, ample boot space, and a peaceful highway drive, perfect for a spiritual temple trip."
  },
  {
    "name": "SUV Cab Mumbai Shani Shingnapur",
    "description": "SUV Cab Mumbai Shani Shingnapur is ideal for families, groups, or passengers needing extra comfort and space on long pilgrim journeys. With powerful engines, spacious seating, and smooth suspension, SUVs ensure a relaxed and enjoyable ride all the way to the Shani Temple."
  },
  {
    "name": "Fastest Cab Mumbai Shani",
    "description": "Fastest Cab Mumbai Shani ensures the quickest and most efficient travel routes towards Shani Shingnapur, using highway-optimized driving and minimal stops. Perfect for passengers on a tight schedule, this service guarantees timely arrival without compromising comfort or safety."
  },
  {
    "name": "Temple Darshan Cab Mumbai",
    "description": "Temple Darshan Cab Mumbai is designed for devotees planning single-temple or combined pilgrimage trips from Mumbai. Offering flexible routes, convenient halts, and dedicated temple travel assistance, passengers can enjoy peaceful darshan with comfort and convenience throughout the journey."
  },
  {
    "name": "Family Cab Mumbai Shani Shingnapur",
    "description": "Family Cab Mumbai Shani Shingnapur ensures safe and comfortable travel for families on their devotional visit. Spacious vehicles, child-friendly seating, smooth driving, and careful route planning make this service ideal for family pilgrimages to the sacred Shani Temple."
  },
  {
    "name": "AC Cab Mumbai Shani",
    "description": "AC Cab Mumbai Shani delivers a cool and comfortable travel environment for long-distance religious journeys. With well-maintained air-conditioned sedans and SUVs, passengers can enjoy a refreshing ride even during summer temple visits or mid-day travel hours."
  },
  {
    "name": "Safe Taxi Mumbai Shani",
    "description": "Safe Taxi Mumbai Shani focuses on secure travel with verified drivers, GPS-enabled vehicles, and disciplined driving standards. This service is ideal for elderly devotees, solo travellers, and families looking for a completely safe and peaceful journey to Shani Shingnapur."
  }
],

"tableData": [
  ["Mumbai Shani Shingnapur Taxi Service", "Shani Temple Cab Mumbai"],
  ["Mumbai to Shani Shingnapur One Way Cab", "Pune–Shani Shingnapur Taxi via Mumbai"],
  ["Affordable Cab Mumbai Shani Shingnapur", "Pilgrimage Cab Mumbai Shani Shingnapur"],
  ["24x7 Cab Mumbai Shani", "Sedan Cab Mumbai Shani Shingnapur"],
  ["SUV Cab Mumbai Shani Shingnapur", "Fastest Cab Mumbai Shani"],
  ["Temple Darshan Cab Mumbai", "Family Cab Mumbai Shani Shingnapur"],
  ["AC Cab Mumbai Shani", "Safe Taxi Mumbai Shani"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Shani Shingnapur Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Shani Shingnapur cab services, perfect for pilgrimage trips, family travel, and comfortable long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and well-maintained cabs to ensure a smooth and pleasant ride from Mumbai to Shani Shingnapur."
  },
  {
    "WhyChooseheading": "Experienced Pilgrimage Route Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with Mumbai to Shani Shingnapur pilgrimage routes, ensuring safe driving, timely arrivals, and a stress-free journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included in your Mumbai to Shani Shingnapur cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to help with bookings, route guidance, and any trip-related questions."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Select from one-way, round-trip, or customized travel plans based on your Mumbai to Shani Shingnapur trip requirements."
  },
  {
    "WhyChooseheading": "Sanitized and Safe Cabs",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before every trip, ensuring a safe and hygienic travel experience for devotees."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Pickup",
    "WhyChoosedescription": "We guarantee timely pickups and dependable service, making your Mumbai to Shani Shingnapur journey smooth, comfortable, and worry-free."
  }
]



























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Shani Shingnapur?',
    answer: 'Yes, Shambhu Cabs offers comfortable and reliable cab services from Mumbai to Shani Shingnapur, making your pilgrimage journey peaceful and hassle-free.',
  },
  {
    question: 'How can I book a cab from Mumbai to Shani Shingnapur?',
    answer: 'You can easily book a cab from Mumbai to Shani Shingnapur through our website, mobile app, or by contacting our 24x7 customer support team for quick and easy bookings.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Shani Shingnapur cab bookings?',
    answer: 'Shambhu Cabs offers a variety of vehicles for the Mumbai to Shani Shingnapur journey, including sedans, SUVs, luxury cars, and Tempo Travellers for group trips and families.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Shani Shingnapur journey?',
    answer: 'Yes, our drivers are licensed, experienced, and familiar with the route to Shani Shingnapur, ensuring a safe and comfortable journey for you and your family.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Shani Shingnapur trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points within Mumbai and Shani Shingnapur for a convenient and personalized travel experience.',
  },
  {
    question: 'Is the Mumbai to Shani Shingnapur cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab services for your pilgrimage trip from Mumbai to Shani Shingnapur, allowing you to travel at your preferred time.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Shani Shingnapur trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your safety and well-being during the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Shani Shingnapur cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for your Mumbai to Shani Shingnapur cab bookings.',
  },
  {
    question: 'Is customer support available during my Mumbai to Shani Shingnapur trip?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey from Mumbai to Shani Shingnapur.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Sharma',
    feedback: 'Our trip from Mumbai to Shani Shingnapur with Shambhu Cabs was very smooth. The driver was courteous, and the car was very comfortable. Highly recommend!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kulkarni',
    feedback: 'Shambhu Cabs made our pilgrimage to Shani Shingnapur easy and stress-free. The service was excellent, and the driver was very professional.',
    rating: 5,
  },
];











































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];







const shaniShingnapurCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Shani Shingnapur Cab",
  "serviceType": "Pilgrimage / Outstation Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-shani-shingnapur-cab.jpg",
  "description": "Book reliable Mumbai to Shani Shingnapur cab services with Shambhu Cabs. Affordable and premium cabs including SUV, sedan, family trips, temple darshan, AC cabs, and 24×7 service.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "750",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-shani-shingnapur-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Shani Shingnapur, India" }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Shani Shingnapur Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Shambhu Cabs offers Mumbai to Shani Shingnapur cab services. Book affordable SUV, sedan, AC, and family cabs for temple darshan and outstation trips, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Shani Shingnapur Taxi Service, Shani Temple Cab Mumbai, Mumbai to Shani Shingnapur One Way Cab, Pune–Shani Shingnapur Taxi via Mumbai, Affordable Cab Mumbai Shani Shingnapur, Pilgrimage Cab Mumbai Shani Shingnapur, 24x7 Cab Mumbai Shani, Sedan Cab Mumbai Shani Shingnapur, SUV Cab Mumbai Shani Shingnapur, Fastest Cab Mumbai Shani, Temple Darshan Cab Mumbai, Family Cab Mumbai Shani Shingnapur, AC Cab Mumbai Shani, Safe Taxi Mumbai Shani"
  />

  <script type="application/ld+json">
    {JSON.stringify(shaniShingnapurCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/62.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoshanishingnapur;